exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.drink-card-refund-container[data-v-3b214f56] { padding: 20px;\n}\n.pagination-container[data-v-3b214f56] { margin-top: 20px; text-align: right;\n}\n", ""]);

// exports
